<template>
  <v-form lazy-validation @submit.prevent="next">
    <v-flex xs12>
      <!-- Selecciona el periodo de vigencia de los subgrupos -->
    </v-flex>
    <div v-for="(day, i) in subgroup.days" :key="i" id="days-subgroups">
      <v-layout wrap row justify-center>
        <v-flex xs12 md9 lg9>
          <h4 style="margin-bottom:10px">Subgrupo {{ i + 1 }}</h4>
          Periodo de vigencia
          <span class="error" v-if="day.startError" style="margin-top: 10px">{{
            day.startError
          }}</span>
          <span class="error" v-if="day.endError" style="margin-top: 10px">{{
            day.endError
          }}</span>
          <v-layout style="margin-top: 5px">
            <v-flex md6>
              <DatePicker
                titleDate="Fecha inicial"
                v-model="day.startDate"
                @input="dateValidate(day)"
                :errorMessages="day.startError"
              />
            </v-flex>
            <v-flex md6>
              <DatePicker
                titleDate="Fecha de término"
                v-model="day.endDate"
                @input="dateValidate(day)"
                :errorMessages="day.endError"
              />
            </v-flex>
          </v-layout>
          <v-checkbox
            color="primary"
            v-model="day.monday"
            label="Lunes"
            hide-details
          />

          <v-checkbox
            color="primary"
            v-model="day.tuesday"
            label="Martes"
            hide-details
          />

          <v-checkbox
            color="primary"
            v-model="day.wednesday"
            label="Miercoles"
            hide-details
          />

          <v-checkbox
            color="primary"
            v-model="day.thursday"
            label="Jueves"
            hide-details
          />

          <v-checkbox
            color="primary"
            v-model="day.friday"
            label="Viernes"
            hide-details
          />

          <v-checkbox
            color="primary"
            v-model="day.saturday"
            label="Sábado"
            hide-details
          />

          <v-checkbox
            color="primary"
            v-model="day.sunday"
            label="Domingo"
            hide-details
          />
        </v-flex>
      </v-layout>
      <br v-if="i + 1 !== subgroup.days.length" />
      <v-divider v-if="i + 1 !== subgroup.days.length" />
      <br v-if="i + 1 !== subgroup.days.length" />
    </div>
  </v-form>
</template>

<script>
import DatePicker from "../../Tools/DatePicker";

export default {
  props: ["subgroup"],
  components: {
    DatePicker,
  },
  data: () => ({}),
  mounted() {},
  methods: {
    removeQuestion(index) {
      this.questionToDeleted = index;
      this.modals.confirmDeleteQuestion = true;
    },
    dateValidate(day) {
      if (day.startDate) {
        const todayTime = new Date();
        todayTime.setHours(0, 0, 0, 0);

        day.startDate.setHours(0, 0, 0, 0);
        const startTime = day.startDate.getTime();

        if (isNaN(startTime)) {
          //invalid
          day.startError = "Ingresa una fecha incial válida.";
        } else if (startTime < todayTime) {
          day.startError = "La fecha inicial debe ser posterior al día de hoy.";
        } else {
          day.startError = "";
        }
      } else day.startError = "Ingresa una fecha inicial.";

      if (day.endDate) {
        if (isNaN(day.endDate.getTime())) {
          //invalid
          day.endError = "Ingresa una fecha final válida.";
        } else if (day.startDate >= day.endDate) {
          day.endError =
            "La fecha de término debe ser posterior a la fecha inicial.";
        } else {
          day.endError = "";
        }
      } else day.endError = "Ingresa una fecha final.";

      if (day.startError) {
        day.start = "";
      } else {
        day.start = `${day.startDate.getFullYear()}-${day.startDate.getMonth() < 9 ? "0" : ""}${day.startDate.getMonth() + 1}-${day.startDate.getDate() < 9 ? "0" : ""}${day.startDate.getDate() + 1}`;
      }

      if (day.endError) {
        day.end = "";
      } else {
        day.end = `${day.endDate.getFullYear()}-${
          day.endDate.getMonth() < 9 ? "0" : ""
        }${day.endDate.getMonth() + 1}-${day.endDate.getDate() < 9 ? "0" : ""}${day.endDate.getDate() + 1}`;
      }
    },
  },
};
</script>

<style>
#days-subgroups .v-input--selection-controls {
  margin-top: 0 !important;
}
</style>
<style scoped>
.error {
  background-color: transparent !important;
  color: #ff5252;
  display: block;
}

/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}
</style>
